import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconCloud(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.004 6.001a4 4 0 0 1 0 8h-6a6 6 0 1 1 5.653-8zm0 1.333h-.84a.669.669 0 0 1-.646-.5 4.667 4.667 0 1 0-4.514 5.833h6a2.667 2.667 0 1 0 0-5.334z"
  }));
}
IconCloud.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconCloud.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconCloud as default };
